import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import loadingGif from "../../assets/images/icons/loadingGif.gif";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Input from "../forms-fields/Input";
import { ToastContainer, toast } from "react-toastify";
import ProgressComponent from "../general/ProgressComponent";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import CustomSelect from "../forms-fields/CustomSelectStaffMembers";
import CustomSelectCheckbox from "../../components/forms-fields/CustomCheckBox";
import camera from "../../assets/images/icons/camera.svg";
import closeImage from "../../assets/images/icons/closeImage.svg";
import moment from 'moment';
import Table from 'react-bootstrap/Table';
import SelectBox from '../../components/forms-fields/SelectBox';
import eventClose from "../../assets/images/icons/eventClose.svg";
import eventAdd from "../../assets/images/icons/eventAdd.svg";
import {
  isSuccess,
  toastErrorMessages,
  toastSuccessMessages,
  catchAsync,
  getRecords,
} from "../../helper/helper";
import {
  CustomOption,
  handleCheckboxChange,
  uploadFile,
  staffDesignationOptions,
  vehicleTypeOptions,
  userInputFields,
  userNokInputFields,
  handleSelectChange,
  updateStaffValidationSchema,
} from "../../helper/helperJsx";
import {
  PUT_USERS_PROFILE_PICTURE_URL,
  POST_UPDATE_STAFF_MEMBER_DETAILS_URL,
  GET_STAFF_PERMISSIONS,
  BASE_URL,
} from "../../env";
import TextArea from "../forms-fields/TextArea";

function UserProfileUpdate({
  showModal,
  closeModal,
  userData,
  fetchAllRecords,
}) {
  const initialUserData = userData;
  const [userDataRecord, setUserDataRecord] = useState(initialUserData);
  const [isFileUploadedToast, setIsFileUploadedToast] = useState(false);
  const [isToastUpdateUserRecord, setIsToastUpdateUserRecord] = useState(false);
  const [isLoadingIcon, setIsLoadingIcon] = useState(false);
  const [profilePicture, setProfilePicture] = useState(
    BASE_URL + initialUserData?.user?.profile_picture_url
  );
  const [isDesignationManager, setIsDesignationManager] = useState(false);
  const [isDesignationSupervisor, setIsDesignationSupervisor] = useState(false);
  const [isHealthCheckedState, setIsHealthCheckedState] = useState(false);
  const [isUpdateFormSubmit, setIsUpdateFormSubmit] = useState(false);
  const [isDriverCheckedState, setIsDriverCheckedState] = useState(false);
  const [isVisaCheckedState, setIsVisaCheckedState] = useState(false);
  const [isAllergiesCheckedState, setIsAllergiesCheckedState] = useState(false);

  const updateUserFormData = useFormik({
    initialValues: {
      title: userDataRecord?.title,
      lastName: userDataRecord?.lastName,
      initials: userDataRecord?.initials,
      secondaryContactNo: userDataRecord?.secondaryContactNo,
      houseFlatNumber: userDataRecord?.houseFlatNumber,
      addressLine1: userDataRecord?.addressLine1,
      town: userDataRecord?.town,
      city: userDataRecord?.city,
      postcode: userDataRecord?.postcode,
      inductionDate: userDataRecord?.inductionDate,

      userId: userDataRecord?.user?._id || initialUserData?._id,
      name: userDataRecord?.user?.name,
      email: userDataRecord?.user?.email,
      password: userDataRecord?.user?.password,
      phoneNumber: userDataRecord?.user?.phoneNumber,
      deviceId: userDataRecord?.user?.deviceId,
      version: userDataRecord?.user?.version,
      role: userDataRecord?.user?.role,
      jobTitle: userDataRecord?.jobTitle,
      userModelName: "staffMembers",
      active: userDataRecord?.user?.active,
      is_verified: userDataRecord?.user?.is_verified,
      approved: userDataRecord?.user?.approved,
      signUpFromWeb: true,
      fcm_tokens: {
        token: "",
        deviceType: userDataRecord?.fcm_tokens?.deviceType,
      },
      location: {
        type: "Point",
        coordinates: [74.28911289869138, 31.624848273644956],
      },
      supervisorId: userDataRecord?.supervisorId?._id,
      managerId: userDataRecord?.managerId?._id,
      stafDob: userDataRecord?.stafDob,
      staffOnLeave: userDataRecord?.staffOnLeave,
      staffDesignation: userDataRecord?.staffDesignation,
      staffRoles: userDataRecord?.user?.staffRoles,
      contractedHours: {
        contractedHours: userDataRecord?.contractedHours?.contractedHours,
        totalShiftHoursWeek:
          userDataRecord?.contractedHours?.totalShiftHoursWeek,
        noOfShifts: userDataRecord?.contractedHours?.noOfShifts,
        perHourRate: userDataRecord?.contractedHours?.perHourRate || 0,
        overNightSleepRate: userDataRecord?.contractedHours?.overNightSleepRate || 0,
        enhancedRate: userDataRecord?.contractedHours?.enhancedRate || 0,
        trainingRate: userDataRecord?.contractedHours?.trainingRate || 0,
        overtimeRate: userDataRecord?.contractedHours?.overtimeRate || 0,
      },
      supervision: {
        supervisionName: userDataRecord?.supervision?.supervisionName,
        sprDueDate: moment(userDataRecord?.supervision?.sprDueDate).valueOf(),
        sprStatus: userDataRecord?.supervision?.sprStatus,
        sprResult: userDataRecord?.supervision?.sprResult,
        templateTitleId: userDataRecord?.supervision?.templateTitleId,
      },
      holidays: [],
      complianceDocuments: [],
      niNumber: userDataRecord?.niNumber,
      // kin: userDataRecord?.kin,
      clients: [],
      covidCheck: userDataRecord?.covidCheck,
      driverFields: {
        isDriver: userDataRecord?.driverFields?.isDriver,
        vehicleType: userDataRecord?.driverFields?.vehicleType,
      },
      // More Detail added to the form
      visaStatus: userDataRecord?.visaStatus,
      firstLanguage: userDataRecord?.firstLanguage,
      visaNumber: userDataRecord?.visaNumber,
      visaExpiry: userDataRecord?.visaExpiry,
      allergiesStatus: userDataRecord?.allergiesStatus,
      allergies: userDataRecord?.allergies,
      nokName: userDataRecord?.nokName,
      nokEmailAddress: userDataRecord?.nokEmailAddress,
      nokPrimaryContact: userDataRecord?.nokPrimaryContact,
      nokSecondaryContact: userDataRecord?.nokSecondaryContact,
      nokHouseFlatNumber: userDataRecord?.nokHouseFlatNumber,
      nokAddressLine: userDataRecord?.nokAddressLine,
      nokTown: userDataRecord?.nokTown,
      nokCity: userDataRecord?.nokCity,
      nokCountry: userDataRecord?.nokCountry,
      nokPostCode: userDataRecord?.nokPostCode,
      importantInfo: userDataRecord?.importantInfo,
    },
    validationSchema: updateStaffValidationSchema,
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        setIsUpdateFormSubmit(true);
        await updateUserRecordFunc(values);
      } catch (error) {
        toastErrorMessages(
          toast?.error,
          "Error . Please try again.",
          "",
          1000,
          1000
        );
        setIsUpdateFormSubmit(false);
      }
    },
  });

  const {
    handleChange,
    handleBlur,
    handleSubmit,
    values,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
    setValues,
  } = updateUserFormData;

  const updateUserRecordFunc = catchAsync(async (req, res) => {
    const response = await getRecords(
      POST_UPDATE_STAFF_MEMBER_DETAILS_URL,
      req
    );
    processFetchRecords("update", response);
  });

  const handleFileChangeUploadDoc = async (e) => {
    try {
      setIsLoadingIcon(true);
      const selectedUploadDocFile = e.target?.files[0];
      const userId = userData?._id || userData?._id;
      await uploadFile({
        isUpload: false,
        updateFieldName: "userId",
        updateFieldId: userId,
        fileName: "file",
        file: selectedUploadDocFile,
        apiUrl: PUT_USERS_PROFILE_PICTURE_URL,
        successCallback: (result) => {
          handleFileChange(e);
          setIsLoadingIcon(false);
          fetchAllRecords();
          setIsFileUploadedToast(true);
          toastSuccessMessages(toast?.success, result?.message, "", 1000, 1000);
        },
      });
    } catch (error) {
      console.error("Error during file upload:", error);
    }
  };

  const processFetchRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      setIsToastUpdateUserRecord(true);
      setIsUpdateFormSubmit(false);
      toastErrorMessages(toast?.error, data?.message, "", 1000, 1000);
    } else if (method === "update" && data?.status === isSuccess) {
      fetchAllRecords();
      setIsUpdateFormSubmit(false);
      setIsToastUpdateUserRecord(true);
      closeModal();
      toastSuccessMessages(toast?.success, data?.message, "", 1000, 1000);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target?.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setProfilePicture(event?.target?.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleManagerSelect = (userId) => {
    handleSelectChange(setFieldValue, "managerId", userId);
  };

  const handleSupervisorSelect = (userId) => {
    handleSelectChange(setFieldValue, "supervisorId", userId);
  };

  const handleSupervisionTemplateSelect = (templateId) => {
    handleSelectChange(
      setFieldValue,
      "supervision.templateTitleId",
      templateId
    );
  };

  useEffect(() => {
    if (values?.staffDesignation && values?.staffDesignation !== null) {
      if (values?.staffDesignation === "manager") {
        setIsDesignationManager(false);
        setIsDesignationSupervisor(true);
      } else if (values?.staffDesignation === "supervisor") {
        setIsDesignationSupervisor(false);
        setIsDesignationManager(true);
      } else {
        setIsDesignationManager(true);
        setIsDesignationSupervisor(true);
      }
    }
  }, [values?.staffDesignation, userDataRecord]);

  const handleIsDriverCheckBox = (e) => {
    handleCheckboxChange(e, setFieldValue, "driverFields.isDriver");
  };

  const handleIsVisaCheckBox = (e) => {
    handleCheckboxChange(e, setFieldValue, "visaStatus");
  };
  const handleIsAllergiesCheckBox = (e) => {
    handleCheckboxChange(e, setFieldValue, "allergiesStatus");
  };

  useEffect(() => {
    if (values?.covidCheck) {
      setIsHealthCheckedState(true);
    } else {
      setIsHealthCheckedState(false);
    }
  }, [values?.covidCheck]);

  useEffect(() => {
    if (values?.driverFields?.isDriver) {
      setFieldValue(
        "driverFields.vehicleType",
        userDataRecord?.driverFields?.vehicleType
      );
      setIsDriverCheckedState(true);
    } else {
      setFieldValue("driverFields.vehicleType", "");
      setIsDriverCheckedState(false);
    }
  }, [values?.driverFields?.isDriver]);

  useEffect(() => {
    if (values?.visaStatus) {
      setIsVisaCheckedState(true);
    } else {
      setIsVisaCheckedState(false);
    }
  }, [values?.visaStatus]);

  useEffect(() => {
    if (values?.allergiesStatus) {
      setIsAllergiesCheckedState(true);
    } else {
      setIsAllergiesCheckedState(false);
    }
  }, [values?.allergiesStatus]);




  const [customOptions, setCustomOptions] = useState(staffDesignationOptions);

  useEffect(() => {
    // Check if the current staffDesignation is not in the options, add it dynamically
    const existingOption = customOptions.find(
      (option) => option.value === values?.staffDesignation
    );

    if (!existingOption && values?.staffDesignation) {
      // Add the new custom value if it's not in the existing options
      setCustomOptions((prevOptions) => [
        ...prevOptions,
        { value: values?.staffDesignation, label: values?.staffDesignation },
      ]);
    }
  }, [values?.staffDesignation]);

  const handleCreateOption = (newOptionLabel) => {
    const newOption = {
      value: newOptionLabel.toLowerCase().replace(/\s+/g, ""),
      label: newOptionLabel,
    };

    setCustomOptions([...customOptions, newOption]);
    setFieldValue("staffDesignation", newOption.value);
  };

  const [permissionItems, setPermissionItems] = useState([]);
  const permissionListQuery = {
    sortProperty: "createdAt",
    sortOrder: -1,
    offset: 0,
    limit: 10,
    query: {
      critarion: {
        active: true,
        permissionName: {
          $nin: [
            "Super Admin",
            "Senior Leadership Team Head",
            "Registered Manager",
            "Operations Manager",
            "HR Manager"
          ]
        }
      }
    }
  }
  const fetchAllPermissionRecords = catchAsync(async (req, res) => {
    const response = await getRecords(GET_STAFF_PERMISSIONS, permissionListQuery);
    const staffPermissions = response?.data?.permissions?.filter((item) =>
      item.permissionName !== "Super Admin" &&
      item.permissionName !== "Senior Leadership Team Head" &&
      item.permissionName !== "Registered Manager" &&
      item.permissionName !== "Operations Manager" &&
      item.permissionName !== "HR Manager");
    const formatedData = staffPermissions?.map((item) => ({
      value: item?._id,
      label: item?.permissionName
    }))

    if (permissionItems?.length === 0) {
      setPermissionItems((prevItems) => [...prevItems, ...formatedData]);
    }

  });
  useEffect(() => {
    fetchAllPermissionRecords();
  }, []);


  //  Allergies Allergiess Points
  const [allergies, setAllergiesPoints] = useState([]);
  useEffect(() => {
    if (values?.allergies?.length > 0) {
      const formatted = values.allergies.map((item, index) => ({
        id: index + 1,
        allergy: item
      }));

      setAllergiesPoints(formatted);
    }
  }, [values?.allergies]);

  const syncAllergiesToFormik = (updatedRows) => {
    setAllergiesPoints(updatedRows);

    // Push plain string array into Formik
    setFieldValue(
      "allergies",
      updatedRows.map((row) => row.allergy)
    );
  };
  const addAllergiesPointsRow = () => {
    const newRow = {
      id: allergies.length + 1,
      allergy: "",
    };

    syncAllergiesToFormik([...allergies, newRow]);
  };

  const removeAllergiesPointsRow = (id) => {
    const filtered = allergies.filter((row) => row.id !== id);
    syncAllergiesToFormik(filtered);
  };

  const handleAllergiesPointsInputChange = (id, value) => {
    const updated = allergies.map((row) =>
      row.id === id ? { ...row, allergy: value } : row
    );

    syncAllergiesToFormik(updated);
  };
  return (
    <>
      <Modal
        show={showModal}
        onHide={closeModal}
        className="ftcModalPopup editProfileModalPopup suProfileEdit"
      >
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <div className="editBlockContent mt-4">
              <div className="row">
                <div className="col-md-12">
                  <div className="closeButton modalCloseButton">
                    <span onClick={closeModal}>
                      <img src={closeImage} alt={closeImage} />
                    </span>
                  </div>

                  <div className="text-center">
                    <label htmlFor="profilePicture" className="upload-icon">
                      {isLoadingIcon ? (
                        <div className="avatarAction">
                          <img src={loadingGif} alt={"Loading..."} />
                        </div>
                      ) : (
                        <div className="avatarAction">
                          <input
                            type="file"
                            id="profilePicture"
                            name="profilePic"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              handleFileChangeUploadDoc(e);
                            }}
                          />
                          <img
                            src={profilePicture}
                            alt={initialUserData?.user?.name}
                            style={{ cursor: "pointer" }}
                          />
                          <span className="uploadImage">
                            <img src={camera} alt="Camera" />
                          </span>
                        </div>
                      )}
                    </label>
                    <h3 className="userTitle">
                      {initialUserData?.user?.name} {" "}
                      {initialUserData?.lastName ? initialUserData?.lastName : ""}
                      <a
                        href={`mailto:${initialUserData?.user?.email}`}
                        className="greyColor"
                      >
                        <small>{initialUserData?.user?.email}</small>
                      </a>
                    </h3>
                  </div>
                  <div className="formBlockContent row">
                    {userInputFields?.map((field, index) => (
                      <div key={index} className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <Input
                            type={field?.type}
                            name={field?.name}
                            value={values[field?.name]}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            labelText={field?.labelText}
                            customError={
                              touched[field?.name] && errors[field?.name]
                            }
                            errorMessage={errors[field?.name]}
                            errorClass={
                              touched[field?.name] && errors[field?.name]
                                ? "validationError"
                                : ""
                            }
                            requiredStar={field?.required}
                          />

                        </div>
                      </div>
                    ))}
                    <div className="col-sm-12 col-md-6">
                      <div className="form-group">
                        <Input
                          type="date"
                          datePicker={true}
                          name="stafDob"
                          selected={values?.stafDob ? moment(values?.stafDob).toDate() : null}
                          dateFormat="dd/MM/yyyy"
                          onChange={(stafDob) => setFieldValue("stafDob", moment(stafDob).valueOf())}
                          onBlur={() => setFieldTouched("stafDob", true)} // Ensure Formik's touched state is set on blur
                          labelText="Date of Birth"
                          placeholderText="Select Start Date"
                          customError={touched?.stafDob && errors?.stafDob}
                          errorMessage={errors?.stafDob}
                          errorClass={touched?.stafDob && errors?.stafDob ? "validationError" : ""}
                          requiredStar={true}
                          showYearDropdown={true}
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="form-group">
                        <Input
                          type="text"
                          id="niNumber"
                          name="niNumber"
                          value={values?.niNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          labelText="Ni Numbers"
                          customError={
                            errors.niNumber && touched.niNumber
                          }
                          errorMessage={errors.niNumber}
                          errorClass={
                            errors.niNumber && touched.niNumber
                          }
                        />
                      </div>
                    </div>


                    {/* Address Fields */}
                    <div className="col-sm-12 col-md-6">
                      <div className="form-group">
                        <Input
                          type="text"
                          id="houseFlatNumber"
                          name="houseFlatNumber"
                          value={values?.houseFlatNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          labelText="House / Flat Number"
                          customError={errors.houseFlatNumber && touched.houseFlatNumber}
                          errorMessage={errors.houseFlatNumber}
                          errorClass={errors.houseFlatNumber && touched.houseFlatNumber}
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="form-group">
                        <Input
                          type="text"
                          id="addressLine1"
                          name="addressLine1"
                          value={values?.addressLine1}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          labelText="Address Line 1"
                          customError={errors.addressLine1 && touched.addressLine1}
                          errorMessage={errors.addressLine1}
                          errorClass={errors.addressLine1 && touched.addressLine1}
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="form-group">
                        <Input
                          type="text"
                          id="town"
                          name="town"
                          value={values?.town}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          labelText="Town"
                          customError={errors.town && touched.town}
                          errorMessage={errors.town}
                          errorClass={errors.town && touched.town}
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="form-group">
                        <Input
                          type="text"
                          id="city"
                          name="city"
                          value={values?.city}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          labelText="City"
                          customError={errors.city && touched.city}
                          errorMessage={errors.city}
                          errorClass={errors.city && touched.city}
                        />
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="form-group">
                        <Input
                          type="text"
                          id="postcode"
                          name="postcode"
                          value={values?.postcode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          labelText="Postcode"
                          customError={errors.postcode && touched.postcode}
                          errorMessage={errors.postcode}
                          errorClass={errors.postcode && touched.postcode}
                        />
                      </div>
                    </div>


                    <div className="col-sm-12 col-md-6">
                      <div className="form-group">
                        <Input
                          type="text"
                          id="firstLanguage"
                          name="firstLanguage"
                          value={values?.firstLanguage}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          labelText="First Language"
                          customError={errors.firstLanguage && touched.firstLanguage}
                          errorMessage={errors.firstLanguage}
                          errorClass={errors.firstLanguage && touched.firstLanguage}
                        />
                      </div>
                    </div>

                    <div className="col-md-12"></div>

                    {isVisaCheckedState ? (
                      <div className="col-sm-12 col-md-12">
                        <div className="form-group mb-2">
                          <CustomSelectCheckbox
                            name="visaStatus"
                            tick={
                              values?.visaStatus
                            }
                            value={isVisaCheckedState}
                            onChange={handleIsVisaCheckBox}
                            onBlur={handleBlur}
                            labelText={"Visa Status"}
                          />
                        </div>
                      </div>
                    ) : null}

                    {!isVisaCheckedState ? (
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <CustomSelectCheckbox
                            name="visaStatus"
                            tick={
                              values?.visaStatus
                            }
                            value={isVisaCheckedState}
                            onChange={handleIsVisaCheckBox}
                            onBlur={handleBlur}
                            labelText={"Visa Status"}
                          />
                        </div>
                      </div>
                    ) : null}

                    {isVisaCheckedState ? (
                      <>
                        <div className="col-sm-12 col-md-6">
                          <div className="form-group">
                            <Input
                              type="text"
                              id="visaNumber"
                              name="visaNumber"
                              value={values?.visaNumber}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              labelText="Visa Number"
                              customError={errors.visaNumber && touched.visaNumber}
                              errorMessage={errors.visaNumber}
                              errorClass={errors.visaNumber && touched.visaNumber}
                            />
                          </div>
                        </div>



                        <div className="col-sm-12 col-md-6">
                          <div className="form-group">
                            <Input
                              type="date"
                              datePicker={true}
                              name="visaExpiry"
                              selected={
                                values?.visaExpiry
                                  ? moment(Number(values.visaExpiry)).toDate()
                                  : null
                              }
                              dateFormat="dd/MM/yyyy"
                              onChange={(visaExpiry) =>
                                setFieldValue("visaExpiry", moment(visaExpiry).valueOf())
                              }
                              onBlur={() => setFieldTouched("visaExpiry", true)} // Ensure Formik's touched state is set on blur
                              labelText="Visa Expiry"
                              placeholderText="Select Date"
                              customError={touched?.visaExpiry && errors?.visaExpiry}
                              errorMessage={errors?.visaExpiry}
                              errorClass={touched?.visaExpiry && errors?.visaExpiry ? "validationError" : ""}
                              requiredStar={true}
                              showYearDropdown={true}
                            />
                          </div>
                        </div>
                      </>
                    ) : null}

                    <div className="col-md-12"></div>

                    {isDriverCheckedState ? (
                      <div className="col-sm-12 col-md-12">
                        <div className="form-group mb-2">
                          <CustomSelectCheckbox
                            name="isDriver"
                            tick={
                              values?.driverFields?.isDriver &&
                              values?.driverFields?.isDriver
                            }
                            value={isDriverCheckedState}
                            onChange={handleIsDriverCheckBox}
                            onBlur={handleBlur}
                            labelText={"Driving Status"}
                          />
                        </div>
                      </div>
                    ) : null}

                    {!isDriverCheckedState ? (
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <CustomSelectCheckbox
                            name="isDriver"
                            tick={
                              values?.driverFields?.isDriver &&
                              values?.driverFields?.isDriver
                            }
                            value={isDriverCheckedState}
                            onChange={handleIsDriverCheckBox}
                            onBlur={handleBlur}
                            labelText={"Driving Status"}
                          />
                        </div>
                      </div>
                    ) : null}

                    {isDriverCheckedState ? (
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <div
                            className={`customSelectBox ${touched?.driverFields?.vehicleType &&
                              errors?.driverFields?.vehicleType
                              ? "validationError"
                              : ""
                              }`}
                          >
                            <>
                              <Select
                                className="basic-multi-select cursor-pointer"
                                classNamePrefix="select"
                                value={vehicleTypeOptions?.find(
                                  (option) =>
                                    option?.value ===
                                    values?.driverFields?.vehicleType
                                )}
                                options={vehicleTypeOptions}
                                onChange={(selectedOptions) => {
                                  setFieldValue(
                                    "driverFields.vehicleType",
                                    selectedOptions?.value
                                  );
                                }}
                                onBlur={handleBlur}
                                isSearchable
                                getOptionLabel={(selectedOptions) =>
                                  selectedOptions?.label
                                }
                                getOptionValue={(selectedOptions) =>
                                  selectedOptions?.value
                                }
                                components={{ Option: CustomOption }}
                              />
                              <label className="floatingLabel">
                                Vehicle Type
                                <span className="text-danger">*</span>
                              </label>
                              {touched?.driverFields?.vehicleType &&
                                errors?.driverFields?.vehicleType && (
                                  <div className="text-danger">
                                    {errors?.driverFields?.vehicleType}
                                  </div>
                                )}
                            </>
                          </div>
                        </div>
                      </div>
                    ) : null}


                    {/* Allergies Status */}
                    <div className="col-md-12"></div>
                    {isAllergiesCheckedState ? (
                      <div className="col-sm-12 col-md-12">
                        <div className="form-group mb-2">
                          <CustomSelectCheckbox
                            name="allergiesStatus"
                            tick={
                              values?.allergiesStatus
                            }
                            value={isAllergiesCheckedState}
                            onChange={handleIsAllergiesCheckBox}
                            onBlur={handleBlur}
                            labelText={"Allergies Status"}
                          />
                        </div>
                      </div>
                    ) : null}

                    {!isAllergiesCheckedState ? (
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <CustomSelectCheckbox
                            name="allergiesStatus"
                            tick={
                              values?.allergiesStatus
                            }
                            value={isAllergiesCheckedState}
                            onChange={handleIsAllergiesCheckBox}
                            onBlur={handleBlur}
                            labelText={"Allergies Status"}
                          />
                        </div>
                      </div>
                    ) : null}
                    {isAllergiesCheckedState ? (
                      <>
                        <div className="actionsPoint">
                          <div className="table-responsive">
                            <Table striped bordered hover className='dynamicRows allergies'>
                              <thead>
                                <tr>
                                  <th style={{ width: "95%" }}>Allergies</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {allergies.map((row, id) => (
                                  <tr>
                                    <td><Input
                                      type="text"
                                      id={`allergy_${row.id}`}
                                      name={`allergy_${row.id}`}
                                      value={row.allergy}
                                      onChange={(e) => handleAllergiesPointsInputChange(row.id, e.target.value)}
                                      // onChange={(e) => handleInputChange(row.id, 'allergies', e.target.value)}
                                      onBlur={handleBlur}
                                    /></td>
                                    <td><img className='removeRow' src={eventClose} alt="Close" onClick={() => { removeAllergiesPointsRow(row.id) }} /></td>
                                  </tr>
                                ))}
                                <tr>
                                  <td></td>
                                  <td><img className='addRow' src={eventAdd} alt="Add" onClick={addAllergiesPointsRow} /></td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </>
                    ) : null}
                    <div className="col-md-12"></div>


                    <div className="col-md-12">
                      <TextArea
                        id="importantInfo"
                        name="importantInfo"
                        value={values?.importantInfo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        labelText="Important Information"
                        rows="3"
                        customError={
                          touched?.importantInfo &&
                          errors?.importantInfo
                        }
                        errorMessage={errors?.importantInfo}
                        erroClass={
                          touched?.importantInfo &&
                            errors?.importantInfo
                            ? "validationError"
                            : ""
                        }

                      />
                    </div>

                    <div className="col-md-12">
                      <p>
                        <strong>NOK Details</strong>
                      </p>
                    </div>
                    {userNokInputFields?.map((field, index) => (
                      <div key={index} className="col-sm-6 col-md-4">
                        <div className="form-group">
                          <Input
                            type={field?.type}
                            id={field?.name}
                            name={field?.name}
                            value={values[field?.name]}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            labelText={field?.labelText}
                            customError={
                              touched[field?.name] && errors[field?.name]
                            }
                            errorMessage={errors[field?.name]}
                            errorClass={
                              touched[field?.name] && errors[field?.name]
                                ? "validationError"
                                : ""
                            }
                            requiredStar={field?.required}
                          />
                        </div>
                      </div>
                    ))}

                    <div className="col-md-12">
                      <p>
                        <strong>Contract Hours</strong>
                      </p>
                    </div>
                    <div className="col-sm-6 col-md-4">
                      <div className="col">
                        <Input
                          type="number"
                          name="contractedHours"
                          value={values?.contractedHours?.contractedHours}
                          onChange={(e) => {
                            setFieldValue(
                              "contractedHours.contractedHours",
                              e.target?.value
                            );
                          }}
                          onBlur={handleBlur}
                          labelText="Contract Hours"
                          customError={
                            touched?.contractedHours?.contractedHours &&
                            errors?.contractedHours?.contractedHours
                          }
                          errorMessage={errors?.contractedHours?.contractedHours}
                          errorClass={
                            touched?.contractedHours?.contractedHours &&
                              errors?.contractedHours?.contractedHours
                              ? "validationError"
                              : ""
                          }
                          requiredStar={true}
                        />
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-4">
                      <div className="col">
                        <Input
                          type="number"
                          name="perHourRate"
                          value={values?.contractedHours?.perHourRate}
                          onChange={(e) => {
                            setFieldValue(
                              "contractedHours.perHourRate",
                              e.target?.value
                            );
                          }}
                          onBlur={handleBlur}
                          labelText="Contracted Hours Rate"
                          customError={
                            touched?.contractedHours?.perHourRate &&
                            errors?.contractedHours?.perHourRate
                          }
                          errorMessage={errors?.contractedHours?.perHourRate}
                          errorClass={
                            touched?.contractedHours?.perHourRate &&
                              errors?.contractedHours?.perHourRate
                              ? "validationError"
                              : ""
                          }
                          requiredStar={true}
                        />
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-4">
                      <div className="col">
                        <Input
                          type="number"
                          name="overNightSleepRate"
                          value={values?.contractedHours?.overNightSleepRate}
                          onChange={(e) => {
                            setFieldValue(
                              "contractedHours.overNightSleepRate",
                              e.target?.value
                            );
                          }}
                          onBlur={handleBlur}
                          labelText="Over Night Sleep Rate"
                          customError={
                            touched?.contractedHours?.overNightSleepRate &&
                            errors?.contractedHours?.overNightSleepRate
                          }
                          errorMessage={errors?.contractedHours?.overNightSleepRate}
                          errorClass={
                            touched?.contractedHours?.overNightSleepRate &&
                              errors?.contractedHours?.overNightSleepRate
                              ? "validationError"
                              : ""
                          }
                          requiredStar={true}
                        />
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-4">
                      <Input
                        type="number"
                        name="enhancedRate"
                        value={values?.contractedHours?.enhancedRate}
                        onChange={(e) => {
                          setFieldValue(
                            "contractedHours.enhancedRate",
                            e.target?.value
                          );
                        }}
                        onBlur={handleBlur}
                        labelText="Enhanced Rate"
                        customError={
                          touched?.contractedHours?.enhancedRate &&
                          errors?.contractedHours?.enhancedRate
                        }
                        errorMessage={errors?.contractedHours?.enhancedRate}
                        errorClass={
                          touched?.contractedHours?.enhancedRate &&
                            errors?.contractedHours?.enhancedRate
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>

                    <div className="col-sm-6 col-md-4">
                      <Input
                        type="number"
                        name="trainingRate"
                        value={values?.contractedHours?.trainingRate}
                        onChange={(e) => {
                          setFieldValue(
                            "contractedHours.trainingRate",
                            e.target?.value
                          );
                        }}
                        onBlur={handleBlur}
                        labelText="Training Rate"
                        customError={
                          touched?.contractedHours?.trainingRate &&
                          errors?.contractedHours?.trainingRate
                        }
                        errorMessage={errors?.contractedHours?.trainingRate}
                        errorClass={
                          touched?.contractedHours?.trainingRate &&
                            errors?.contractedHours?.trainingRate
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>

                    <div className="col-sm-6 col-md-4">
                      <Input
                        type="number"
                        name="overtimeRate"
                        value={values?.contractedHours?.overtimeRate}
                        onChange={(e) => {
                          setFieldValue(
                            "contractedHours.overtimeRate",
                            e.target?.value
                          );
                        }}
                        onBlur={handleBlur}
                        labelText="Overtime Rate"
                        customError={
                          touched?.contractedHours?.overtimeRate &&
                          errors?.contractedHours?.overtimeRate
                        }
                        errorMessage={errors?.contractedHours?.overtimeRate}
                        errorClass={
                          touched?.contractedHours?.overtimeRate &&
                            errors?.contractedHours?.overtimeRate
                            ? "validationError"
                            : ""
                        }
                        requiredStar={true}
                      />
                    </div>



                    {/* Other fields */}
                    <p>
                      <strong>Staff Role</strong>
                    </p>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div
                          className={`customSelectBox ${errors?.staffDesignation ? "validationError" : ""
                            }`}
                        >
                          <CreatableSelect
                            isClearable={true}
                            name="staffDesignation"
                            value={customOptions.find(
                              (option) => option?.value === values?.staffDesignation
                            )}
                            className="basic-multi-select cursor-pointer"
                            classNamePrefix="select"
                            options={customOptions}
                            onChange={(selectedOption) => {
                              setFieldValue("staffDesignation", selectedOption?.value);
                            }}
                            onCreateOption={handleCreateOption} // Add this to handle new custom options
                            isSearchable
                            getOptionLabel={(option) => option?.label}
                            getOptionValue={(option) => option?.value}
                            components={{ Option: CustomOption }}
                          />
                          <label className="floatingLabel">
                            Staff Roles
                            {/* <span className="text-danger">*</span> */}
                          </label>
                          {errors?.staffDesignation && (
                            <div className="text-danger">{errors?.staffDesignation}</div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <Input
                          type="text"
                          id="jobTitle"
                          name="jobTitle"
                          value={values?.jobTitle}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          labelText="Job Title"
                          customError={
                            touched?.jobTitle &&
                            errors?.jobTitle
                          }
                          errorMessage={errors?.jobTitle}
                          errorClass={
                            touched?.jobTitle &&
                              errors?.jobTitle
                              ? "validationError"
                              : ""
                          }
                          requiredStar={true}
                        />
                      </div>
                    </div>

                    {isDesignationSupervisor && (

                      <div className="col-md-6">
                        <div className="form-group">
                          <CustomSelect
                            value={values?.supervisorId}
                            defaultValue={values?.supervisorId}
                            filterBy="supervisor"
                            onSelect={handleSupervisorSelect}
                            customError={
                              touched?.supervisorId && errors?.supervisorId
                            }
                            errorMessage={errors?.supervisorId}
                            errorClass={
                              touched?.supervisorId && errors?.supervisorId
                                ? "validationError"
                                : ""
                            }
                            label="Supervisor"
                            requiredStar={true}
                          />
                        </div>
                      </div>

                    )}
                    {isDesignationManager && (
                      <div className="col-md-6">
                        <div className="form-group">
                          <CustomSelect
                            value={values?.managerId}
                            defaultValue={values?.managerId}
                            onSelect={handleManagerSelect}
                            filterBy="manager"
                            label="Manager"
                            customError={
                              touched?.managerId && errors?.managerId
                            }
                            errorMessage={errors?.managerId}
                            errorClass={
                              touched?.managerId && errors?.managerId
                                ? "validationError"
                                : ""
                            }
                            requiredStar={true}
                          />
                        </div>
                      </div>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {isUpdateFormSubmit ? (
              <ProgressComponent />
            ) : (
              <>
                <Button
                  className="btn-sm"
                  variant="outline-primary"
                  onClick={closeModal}
                >
                  Close
                </Button>
                <Button className="btn-sm" variant="primary" type="submit">
                  Update
                </Button>
              </>
            )}
          </Modal.Footer>
        </form>
      </Modal>
      {isFileUploadedToast && <ToastContainer />}
      {isToastUpdateUserRecord && <ToastContainer />}
    </>
  );
}

export default UserProfileUpdate;
